var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.spinClass},[_c('v-icon',{on:{"click":_vm.handleRefresh}},[_vm._v("mdi-refresh")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }